<template>
  <div class="container-fluid pt-3 px-9">
    <!-- Filters -->
    <placeholder-analytic-kpi v-if="loading"/>
    <div v-else class="w-100 h-screen bg-white">
      <iframe
        title="QuickSight Dashboard"
        :src="dashboardUrl"
        frameborder="0"
        allowfullscreen
        class="w-100 h-full"
        style="min-height: 800px;">
      </iframe>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import placeholderAnalyticKpi from '../../../../components/loadings/placeholderAnalyticKpis.vue';
export default {
  name: "performance-ia",
  components: {
    placeholderAnalyticKpi
  },
  data() {
    return {
      loading: true,
      filter : {},
      dashboardUrl: ''
    };
  },
  computed: {
    ...mapGetters(["authentication_user"]),
  },
  created(){
    this.getFilter()
  },
  methods: {
    ...mapActions([
        'get'
    ]),
    getFilter(){
      this.loading = true;
      let client_name = `c-${this.authentication_user.client_name.toLowerCase().replace(/\s+/g, '')}`;
      this.get({
        url: `https://u6r680bho3.execute-api.us-east-1.amazonaws.com/prod/dashboard-url/?client_name=${client_name}&client_product=performance`
      }).then((response) => {
        this.dashboardUrl = response.url;
        this.loading = false
      })
    }
  },
};
</script>
<style scoped>
  .container-fluid{
    position: relative;
    float: left;
  }
</style>